import type { CrmTranslate } from './crm-copy';

export function createCrmDashboardCopy(t: CrmTranslate) {
  return {
    dashboardPage: {
      documentTitle: t('crm.dashboardPage.documentTitle'),
      title: t('crm.dashboardPage.title'),
      actions: {
        customize: t('crm.dashboardPage.actions.customize'),
        customizeDashboard: t('crm.dashboardPage.actions.customizeDashboard'),
        closeCustomizer: t('crm.dashboardPage.actions.closeCustomizer'),
        resetToDefaults: t('crm.dashboardPage.actions.resetToDefaults'),
        done: t('crm.dashboardPage.actions.done'),
      },
      customizePanel: {
        title: t('crm.dashboardPage.customizePanel.title'),
        sizeOptions: {
          half: t('crm.dashboardPage.customizePanel.sizeOptions.half'),
          full: t('crm.dashboardPage.customizePanel.sizeOptions.full'),
        },
      },
      states: {
        noWidgetsTitle: t('crm.dashboardPage.states.noWidgetsTitle'),
        noWidgetsDescription: t('crm.dashboardPage.states.noWidgetsDescription'),
      },
    },
    dashboardWidgets: {
      common: {
        viewAll: t('crm.dashboardWidgets.common.viewAll'),
        trendNoChange: t('crm.dashboardWidgets.common.trendNoChange'),
        noValue: t('crm.dashboardWidgets.common.noValue'),
        minutesAgo: (minutes: number) =>
          t('crm.dashboardWidgets.common.minutesAgo', {
            values: { minutes },
          }),
        hoursAgo: (hours: number) =>
          t('crm.dashboardWidgets.common.hoursAgo', {
            values: { hours },
          }),
        daysAgo: (days: number) =>
          t('crm.dashboardWidgets.common.daysAgo', {
            values: { days },
          }),
      },
      tasks: {
        title: t('crm.dashboardWidgets.tasks.title'),
        openTasks: t('crm.dashboardWidgets.tasks.openTasks'),
        overdue: t('crm.dashboardWidgets.tasks.overdue'),
        dueSoon: t('crm.dashboardWidgets.tasks.dueSoon'),
        noDueDate: t('crm.dashboardWidgets.tasks.noDueDate'),
        dueToday: t('crm.dashboardWidgets.tasks.dueToday'),
        dueTomorrow: t('crm.dashboardWidgets.tasks.dueTomorrow'),
        daysOverdue: (days: number) =>
          t('crm.dashboardWidgets.tasks.daysOverdue', {
            values: { days },
          }),
        dueInDays: (days: number) =>
          t('crm.dashboardWidgets.tasks.dueInDays', {
            values: { days },
          }),
        completedThisWeek: (completed: number, percent: number) =>
          t('crm.dashboardWidgets.tasks.completedThisWeek', {
            values: { completed, percent },
          }),
      },
      companies: {
        title: t('crm.dashboardWidgets.companies.title'),
        totalCompanies: t('crm.dashboardWidgets.companies.totalCompanies'),
        newThisWeek: t('crm.dashboardWidgets.companies.newThisWeek'),
      },
      contacts: {
        title: t('crm.dashboardWidgets.contacts.title'),
        totalContacts: t('crm.dashboardWidgets.contacts.totalContacts'),
        newThisWeek: t('crm.dashboardWidgets.contacts.newThisWeek'),
      },
      deals: {
        title: t('crm.dashboardWidgets.deals.title'),
        activeDeals: t('crm.dashboardWidgets.deals.activeDeals'),
        pipelineValue: t('crm.dashboardWidgets.deals.pipelineValue'),
      },
      pipelineStages: {
        title: t('crm.dashboardWidgets.pipelineStages.title'),
        viewPipeline: t('crm.dashboardWidgets.pipelineStages.viewPipeline'),
        noStagesConfigured: t('crm.dashboardWidgets.pipelineStages.noStagesConfigured'),
        noPipelineFound: t('crm.dashboardWidgets.pipelineStages.noPipelineFound'),
      },
      registry: {
        descriptions: {
          contactsSummary: t('crm.dashboardWidgets.registry.descriptions.contactsSummary'),
          companiesSummary: t('crm.dashboardWidgets.registry.descriptions.companiesSummary'),
          dealsSummary: t('crm.dashboardWidgets.registry.descriptions.dealsSummary'),
          tasksSummary: t('crm.dashboardWidgets.registry.descriptions.tasksSummary'),
          pipelineStages: t('crm.dashboardWidgets.registry.descriptions.pipelineStages'),
        },
      },
    },
  };
}
